import(/* webpackMode: "eager" */ "/app/app/(providers)/obs-gyn-surgery-detailpage/page.js");
